import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import charactersData from '../story/the-missing-hour/characters_data.json';
import Header from './Header';

const SuspectDetail = () => {
  const { suspectId } = useParams();
  const navigate = useNavigate();

  
  // Find the suspect by ID
  const suspect = charactersData.characters.find(char => char.id === suspectId);
  
  if (!suspect) {
    return <div>Suspect not found</div>;
  }

  const handleStartInterview = () => {
    navigate(`/interview/${suspectId}`);
  };

  const handleBackToDatabase = () => {
    // Navigate directly to the suspects tab in the database
    navigate('/database#suspects');
  };

  // Function to get the correct image source
  const getImageSource = (character) => {
    // First try to use the profile_photo from the data if it exists and is not null
    if (character.profile_photo && character.profile_photo !== null) {
      return character.profile_photo;
    }
    
    // For suspects, try to load mugshot images
    if (character.role === 'suspect') {
      return `/story/the-missing-hour/suspects/${character.id}_mugshot.jpg`;
    }
    
    // For other characters, try to load from images directory
    if (character.id === 'deputy_detective') {
      return '/story/the-missing-hour/images/sarah_collins.jpg';
    }
    
    // Return null to trigger the fallback display
    return null;
  };

  return (
    <div className="suspect-detail-container">
      <Header />
      
      <div className="suspect-detail-content">
        <button className="back-button" onClick={handleBackToDatabase}>
          ← Back to Suspects
        </button>
        
        <div className="suspect-detail-header">
          <div className="suspect-photo-section">
            {getImageSource(suspect) ? (
              <img 
                src={getImageSource(suspect)}
                alt={`${suspect.name} - ${suspect.role === 'suspect' ? 'Police Mugshot' : 'Profile Photo'}`}
                className="suspect-mugshot"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <div className="suspect-photo-fallback" style={{ display: getImageSource(suspect) ? 'none' : 'flex' }}>
              <div className="suspect-initial-large">
                {suspect.name.split(' ').map(n => n[0]).join('')}
              </div>
            </div>
          </div>
          
          <div className="suspect-info-section">
            <h1 className="suspect-name">{suspect.name}</h1>
            <div className="suspect-role-badge">{suspect.role}</div>
            <div className="suspect-status-badge">
              {suspect.role === 'suspect' ? 'Active Suspect' : 
               suspect.role === 'investigator' ? 'Lead Investigator' :
               suspect.role === 'victim' ? 'Victim' : 'Person of Interest'}
            </div>
          </div>
        </div>

        <div className="suspect-details-grid">
          <div className="detail-section">
            <h3>Connection to Victim</h3>
            <p>{suspect.connection_to_victim}</p>
          </div>
          
          <div className="detail-section">
            <h3>Personality Profile</h3>
            <p>{suspect.personality}</p>
          </div>
          
          <div className="detail-section">
            <h3>Behavior in Interview</h3>
            <p>{suspect.behaviour_in_interview}</p>
          </div>
          
          <div className="detail-section">
            <h3>Days Involved</h3>
            <p>Day {suspect.involvement_days.join(', Day ')}</p>
          </div>
        </div>

        <div className="suspect-notes">
          <h3>Investigation Notes</h3>
          <p>{suspect.notes_reveals}</p>
        </div>

        {suspect.role === 'suspect' && (
          <div className="interview-section">
            <h3>Interview Session</h3>
            <p className="interview-description">
              You have 10 minutes to conduct this interview. Ask strategic questions to gather information 
              about the case. Pay attention to behavioral cues and inconsistencies in their story.
            </p>
            
            <button 
              className="start-interview-btn"
              onClick={handleStartInterview}
            >
              START INTERVIEW (10 MIN)
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SuspectDetail;
